/**
 * The languages Open Songster ships.
 *
 * Every catalog except English is loaded on demand: eight bundled catalogs
 * would add ~65 kB to a first load that, for most people, uses one of them.
 * English is bundled because it is also the fallback for any key a translation
 * is missing.
 */
export const SUPPORTED_LOCALES = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' },
  { code: 'it', label: 'Italiano' },
  { code: 'ja', label: '日本語' },
  { code: 'zh-Hans', label: '简体中文' },
  { code: 'ko', label: '한국어' },
] as const

export type LocaleCode = (typeof SUPPORTED_LOCALES)[number]['code']

export const DEFAULT_LOCALE: LocaleCode = 'en'

export const LOCALE_CODES: readonly LocaleCode[] = SUPPORTED_LOCALES.map((locale) => locale.code)

export function isSupportedLocale(value: string): value is LocaleCode {
  return (LOCALE_CODES as readonly string[]).includes(value)
}
